import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BsModalService } from 'ngx-bootstrap/modal';

import { HelperService } from 'src/app/shared/helper.service';
import { Enterprise } from 'src/app/shared/models';
import { EnterpriseSelectorModalComponent } from './enterprise-selector-modal/enterprise-selector-modal.component';

@Component({
	selector: 'pk-broker-enterprise-selector',
	templateUrl: './enterprise-selector.component.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			// eslint-disable-next-line @typescript-eslint/no-use-before-define
			useExisting: EnterpriseSelectorComponent,
		},
	],
	standalone: false,
})
export class EnterpriseSelectorComponent implements ControlValueAccessor {
	public enterprise: Enterprise = null;
	public inputId: string;

	public disabled = false;
	private touched = false;

	@Output() selection = new EventEmitter<Enterprise>();

	@Input()
	label = 'Enterprise';
	@Input()
	isRequired = false;
	@Input()
	nullEnterpriseText = '-- None --';
	@Input()
	controlType: 'form' | 'filter' = 'form';
	@Input()
	set initialValue(enterprise: Enterprise) {
		if (enterprise) {
			this.writeValue(enterprise);
		}
	}

	constructor(private modalService: BsModalService) {
		this.inputId = HelperService.getUniqueId();
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onChange = (_enterprise: Enterprise) => {
		/* placeholder for interface */
	};
	onTouched = () => {
		/* placeholder for interface */
	};

	showLookupEnterprise() {
		const modalRef = this.modalService.show(EnterpriseSelectorModalComponent, {
			class: 'pk-modal modal-xl',
		});
		modalRef.content.onSubmit.subscribe((enterprise: Enterprise) => {
			this.markAsTouched();
			this.enterprise = enterprise;
			this.onChange(this.enterprise);
			this.selection.emit(this.enterprise);
		});
	}

	public clearEnterprise(): void {
		this.markAsTouched();
		this.enterprise = null;
		this.onChange(this.enterprise);
		this.selection.emit(this.enterprise);
	}

	writeValue(enterprise: Enterprise) {
		this.enterprise = enterprise;
	}

	registerOnChange(onChange: (enterprise: Enterprise) => void) {
		this.onChange = onChange;
	}

	registerOnTouched(onTouched: () => void) {
		this.onTouched = onTouched;
	}

	markAsTouched() {
		if (!this.touched) {
			this.onTouched();
			this.touched = true;
		}
	}

	setDisabledState(disabled: boolean) {
		this.disabled = disabled;
	}
}
